import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useTitleHandler } from "../../customHooks/useTitleHandler";
import { AppImages } from "../../Helpers/AppImages";
import moment from "moment";
import AppConstants from "../../Helpers/AppConstants";
import Navbar from "../../components/Navbar";
import "./home.css";

export default function Index() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  useTitleHandler(t("dtHome"));
  const { token } = useSelector((state) => state.AuthenticationReducer);
  const [isActive, setActive] = useState(false); // need to check
  const dashboard = AppConstants.routes.dashboard;
  const { lng } = useSelector((state) => state.languageReducer);

  useEffect(() => {
    if (token) {
      navigate(dashboard);
    }
  }, [token]);

  const ToggleClass = () => {
    setActive(!isActive);
  };
  return (
    <div>
      <div id="___gatsby">
        <div
          style={{ outline: "none" }}
          tabIndex="-1"
          id="gatsby-focus-wrapper"
        >
          <div className="bg-white">
            <Navbar />

            <main>
              <div className="max-w-full overflow-hidden">
                <section
                  dir="ltr"
                  className="relative py-8 overflow-hidden bg-no-repeat md:py-16 hero blue-slant mb-8"
                >
                  <div className="absolute inset-0 w-full h-full max-w-screen-xl mx-auto">
                    <img
                      src={AppImages.blueDots}
                      alt=""
                      className="absolute bottom-0 right-0 w-full xl:-right-56 sm:w-5/6 lg:-bottom-24 lg:max-w-screen-md xl:max-w-screen-lg"
                      style={{
                        marginRight: -19,
                        zIndex: 99,
                      }}
                    />
                  </div>
                  <svg
                    width="1440"
                    height="575"
                    viewBox="0 0 1439 575"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="absolute bottom-[-1px] left-0 z-10 w-full h-auto"
                  >
                    <path
                      d="M1440-.202V575H0v-40.158c58.457 14.89 121.918 24.658 192.6 24.658 163.075 0 280.954-74.062 395.027-116.702 34.256-12.805 68.169-25.482 102.859-36.798 119.005-38.821 212.825-69.094 301.601-88.277C1043 306.721 1176.5 258 1229.5 218S1370.08 86.28 1440-.202Z"
                      fill="#EBF7FF"
                    ></path>
                  </svg>
                  <div className="relative flex flex-col max-w-screen-xl px-6 mx-auto overflow-visible xl:items-start flex-nowrap lg:flex-row">
                    <div className="z-40 w-full mb-12 lg:mb-0 lg:pr-20 sm:mb-0 lg:w-1/2">
                      <h1
                        className={`leading-none text-5xl text-white font-black tracking-tight max-w-xl mb-0 md:text-[4rem] lg:leading-[4.5rem] ${lng == "ar"
                            ? "xl:leading-[5.5rem] lg:text-6xl"
                            : "xl:leading-[4.5rem] lg:text-[5.5rem]"
                          }`}
                      >
                        {t("welcomeToYourAllInOne")}
                      </h1>
                      <h2
                        className={`sp-m5x font-bold text-white lg:leading-none text-2xl md:text-4xl lg:max-w-sm lg:transform mt-0 relative lg:-top-16 lg:ml-40 lg:-rotate-6 ${lng == "ar" ? "lg:text-2xl" : "lg:text-4xl"
                          }`}
                      >
                        {t("hrPartner")}
                      </h2>
                      <div className="relative mb-4 text-white hero-harry-redknapp-content">
                        <p className="mb-4 last:mb-0">
                          {t("resourceConsumingHrProcesses")}
                        </p>
                      </div>
                      <p className="block mt-4 text-white">
                        <strong>{t("interestedToKnowMore")}</strong>
                        <br />
                        <a
                          href="#"
                          className="underline"
                          data-mdb-toggle="modal"
                          data-mdb-target="#askForDemoModal"
                        >
                          {t("arrangeAConsultation")}
                        </a>
                        .
                      </p>
                    </div>
                  </div>
                </section>
                <div className="mb-6 md:mb-12 last:mb-0">
                  <div className="Copy__Container-sc-34p95u-0 ecQlhJ w-full mx-auto mb-8 rounded">
                    <div className="mx-auto w-full px-6 container">
                      <h2
                        id="heres-how-brighthr-helps-you"
                        className="mb-4 font-bold leading-none last:mb-0 text-xl md:text-2xl"
                      >
                        {t("keepsYourManagerInformed")}
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="mb-6 md:mb-12 last:mb-0">
                  <section className="last:mb-0">
                    <div className="container p-6 py-8 mx-auto overflow-visible flex flex-wrap items-start">
                      <div className="w-full pt-1 lg:mb-0 lg:pr-20 lg:w-1/2">
                        <div className="lazyload-placeholder">
                          <img src={AppImages.lft_sec_1} alt="..." />
                        </div>
                      </div>
                      <div className="w-full lg:pt-8 lg:w-1/2">
                        <h2
                          id="always-know-whos-in-and-whos-off"
                          className="mb-4 font-bold leading-none last:mb-0 text-xl md:text-2xl"
                        >
                          {t("simplifiedTimeAndAttendance")}
                        </h2>
                        <p className="mb-4 last:mb-0">
                          {t("cloudBasedAttendanceManagement")}
                          <ul className="list-disc pl-12">
                            <li>
                              <strong>{t("createAndManageRotas")}</strong>–{" "}
                              {t(
                                "preventAbsenceClashesByCreatingStaffingPlans"
                              )}
                            </li>
                            <li>
                              <strong>{t("monitorAttendance")}</strong> –{" "}
                              {t("mobileFriendlySystem")}
                            </li>
                            <li>
                              <strong>
                                {t("manageLeaveRequestsWithEase")}
                              </strong>{" "}
                              -{t("timeOffNotifications")}
                            </li>
                            <li>
                              <strong>{t("reporting")}</strong> –{" "}
                              {t("payrollProcessing")}
                            </li>
                          </ul>
                        </p>
                      </div>
                    </div>
                  </section>
                </div>
                <div className="mb-6 md:mb-12 last:mb-0">
                  <section className="last:mb-0">
                    <div className="container p-6 py-8 mx-auto overflow-visible flex flex-wrap items-start">
                      <div className="w-full lg:pt-8 lg:w-1/2">
                        <h2
                          id="enjoy-unlimitedyes-unlimiteddocument-storage-space"
                          className="mb-4 font-bold leading-none last:mb-0 text-xl md:text-2xl"
                        >
                          {t("storageSafety")}
                        </h2>
                        <p className="mb-4 last:mb-0">
                          {t("payrollProcessing")}
                        </p>
                        <p className="mb-4 last:mb-0">
                          {t("mobileFriendlySoftware")}
                        </p>
                        <p className="mb-4 last:mb-0">
                          {t("personnelFilesSecurity")}
                        </p>
                        <p className="mb-4 last:mb-0">
                          {t("viewMissingAndOutdatedInformation")}
                        </p>
                        <p className="mb-4 last:mb-0">
                          {t("separateStorageForCompanyPolicies")}
                        </p>
                        <p className="mb-4 last:mb-0">
                          {t("needSupportWithPolicies")}
                        </p>
                      </div>
                      <div className="order-last w-full pt-1 lg:mb-0 lg:pl-20 lg:w-1/2 lg:order-none">
                        <img src={AppImages.lft_sec_2} alt="..." />
                      </div>
                    </div>
                  </section>
                </div>
                <div className="md:mb-12 last:mb-0">
                  <section className="last:mb-0">
                    <div className="container p-6 py-8 mx-auto overflow-visible flex flex-wrap items-start">
                      <div className="w-full pt-1 lg:mb-0 lg:pr-20 lg:w-1/2">
                        {" "}
                        <img src={AppImages.lft_sec_3} alt="..." />{" "}
                      </div>
                      <div className="w-full lg:pt-8 lg:w-1/2">
                        <h2
                          id="get-instant-hr-advice-in-simple-terms"
                          className="mb-4 font-bold leading-none last:mb-0 text-xl md:text-2xl"
                        >
                          {t("yourOneStopHrLibrary")}
                        </h2>
                        <p className="mb-4 last:mb-0">
                          {t("accessToComprehensiveLibrary")}
                        </p>
                        <p className="mb-4 last:mb-0">
                          {t("dealingWithJobOffers")}
                        </p>
                        <p className="mb-4 last:mb-0">
                          {t("cipdQualifiedProfessionals")}
                        </p>
                        <p className="mb-4 last:mb-0">
                          {t("hrLibrary")}
                          &gt; {t("pickYourTemplate")} &gt;{" "}
                          {t("downloadItInstantly")}
                          &gt; {t("customiseItToYourNeeds")} &gt;{" "}
                          {t("easilyPrintOrShareDigitally")}
                        </p>
                        <p className="mb-4 last:mb-0">
                          {t("downloadDocuments")}
                        </p>
                        <a
                          href="#"
                          className="btn btn-primary-outline-cs"
                          data-mdb-toggle="modal"
                          data-mdb-target="#askForDemoModal"
                        >
                          {t("bookConsultation")}
                        </a>
                      </div>
                    </div>
                  </section>
                </div>
                <div className="mb-0 md:mb-12 last:mb-0">
                  <section className="last:mb-0">
                    <div className="container p-6 py-8 mx-auto overflow-visible flex flex-wrap items-start">
                      <div className="w-full lg:pt-8 lg:w-1/2">
                        <h2
                          id="so-what-is-hr-software"
                          className="mb-4 font-bold leading-none last:mb-0 text-xl md:text-2xl"
                        >
                          {t("whyUseHrSoftware")}
                        </h2>
                        <p className="mb-4 last:mb-0">
                          {t("digitalSolutions")}
                        </p>
                        <p className="mb-4 last:mb-0">
                          {t("automatingManualHrTasks")}
                        </p>
                        <h2
                          id="so-what-is-hr-software"
                          className="mb-4 font-bold leading-none last:mb-0 text-xl md:text-2xl"
                        >
                          {t("whyUseSpeedyHr")}
                        </h2>
                        <p className="mb-4 last:mb-0">
                          {t("weAreYourPartners")}
                        </p>
                        <p className="mb-4 last:mb-0">
                          {t("meetYourBusinessNeeds")}
                        </p>
                        <p className="mb-4 last:mb-0">
                          {t("ourSoftwareKeepsYourTeamsConnected")}
                        </p>
                        <p className="mb-4 last:mb-0">
                          {t("cipdQualifiedAdvisors")}
                        </p>
                      </div>
                      <div className="order-last w-full pt-1 lg:mb-0 lg:pl-20 lg:w-1/2 lg:order-none">
                        <img src={AppImages.lft_sec_6} alt="..." />
                      </div>
                    </div>
                  </section>
                </div>
                <div className="mb-6 md:mb-12 last:mb-0"></div>
                <div className="container p-6 py-8 mx-auto overflow-visible "></div>
              </div>
            </main>
            <footer id="footer">
              <div className="container p-6 py-10 mx-auto">
                <div className="md:grid md:grid-cols-3 lg:grid-cols-4 lg:gap-12">
                  <div>
                    <img
                      src={AppImages.logo}
                      alt="SpeedyHR Icon"
                      width="100%"
                      className="mb-4"
                    />
                    <p className="mb-4">{t("smartHrSoftware")}</p>
                    <div className="mb-6">
                      <div className="flex mb-6 text-white">
                        <a
                          href="https://facebook.com"
                          title="Facebook"
                          data-footer-link="social"
                        >
                          <svg
                            width="32"
                            fill="#0057AD"
                            aria-hidden="true"
                            viewBox="0 0 37 37"
                            className="mr-1"
                          >
                            <circle
                              cx="18.5"
                              cy="18.5"
                              r="17.5"
                              stroke="currentColor"
                              stroke-width="2"
                            ></circle>
                            <path
                              fill="currentColor"
                              d="M21.723 20l.445-2.896h-2.779v-1.879c0-.792.388-1.564 1.633-1.564h1.263v-2.465S21.139 11 20.043 11c-2.289 0-3.784 1.387-3.784 3.898v2.206h-2.544V20h2.544v7h3.13v-7h2.334z"
                            >
                              {" "}
                            </path>
                          </svg>
                        </a>
                        <a
                          href="https://twitter.com"
                          title="Twitter"
                          data-footer-link="social"
                        >
                          <svg
                            width="32"
                            fill="#0057AD"
                            aria-hidden="true"
                            viewBox="0 0 37 37"
                            className="mr-1"
                          >
                            <circle
                              cx="18.5"
                              cy="18.5"
                              r="17.5"
                              stroke="currentColor"
                              stroke-width="2"
                            ></circle>
                            <path
                              fill="currentColor"
                              d="M25.355 15.741c.01.142.01.284.01.427 0 4.335-3.299 9.33-9.33 9.33A9.267 9.267 0 0111 24.024c.264.03.518.041.792.041a6.567 6.567 0 004.07-1.401 3.285 3.285 0 01-3.065-2.274c.203.03.406.05.62.05.294 0 .588-.04.862-.111a3.28 3.28 0 01-2.63-3.218v-.04c.437.243.945.395 1.483.415a3.277 3.277 0 01-1.462-2.73c0-.61.162-1.168.447-1.655a9.32 9.32 0 006.761 3.431 3.705 3.705 0 01-.081-.751 3.278 3.278 0 013.28-3.28 3.27 3.27 0 012.395 1.036 6.457 6.457 0 002.081-.792 3.27 3.27 0 01-1.441 1.807c.66-.07 1.3-.254 1.888-.507a7.048 7.048 0 01-1.645 1.695z"
                            >
                              {" "}
                            </path>
                          </svg>
                        </a>
                        <a
                          href="https://youtube.com"
                          title="Youtube"
                          data-footer-link="social"
                        >
                          <svg
                            width="32"
                            aria-hidden="true"
                            fill="none"
                            viewBox="0 0 37 37"
                            className="mr-1"
                          >
                            <circle
                              cx="18.5"
                              cy="18.5"
                              r="17.5"
                              fill="#0057AD"
                            ></circle>
                            <path
                              d="M21.038 22.636v2.338c0 .495-.144.742-.432.742-.17 0-.336-.081-.498-.244v-3.335c.162-.163.328-.244.498-.244.288 0 .432.248.432.743zm3.746.01v.51h-.997v-.51c0-.502.166-.753.498-.753.333 0 .499.251.499.754zM14.08 20.232h1.185V19.19h-3.457v1.042h1.164v6.305h1.108v-6.305zm3.191 6.305h.986v-5.474h-.986v4.189c-.222.31-.432.465-.632.465-.133 0-.21-.077-.232-.233a3.08 3.08 0 01-.011-.387v-4.034h-.987v4.333c0 .362.03.631.089.809.089.273.303.41.643.41.354 0 .731-.226 1.13-.676v.598zm4.754-1.64v-2.183c0-.539-.034-.905-.1-1.097-.126-.413-.388-.62-.787-.62-.37 0-.713.2-1.03.598V19.19h-.986v7.347h.986v-.532c.332.407.676.61 1.03.61.4 0 .661-.203.787-.61.066-.2.1-.569.1-1.108zm3.745-.11v-.145h-1.008c0 .377-.008.602-.023.676-.051.266-.199.4-.443.4-.34 0-.51-.256-.51-.765v-.964h1.984v-1.142c0-.583-.1-1.012-.3-1.285-.287-.377-.679-.565-1.174-.565-.502 0-.897.188-1.185.565-.207.273-.31.702-.31 1.285v1.917c0 .584.107 1.012.32 1.286.289.376.688.565 1.197.565.532 0 .931-.196 1.197-.588.133-.199.21-.398.233-.598.015-.066.022-.28.022-.643zm-6.737-10.118v-2.326c0-.51-.159-.765-.477-.765-.317 0-.476.255-.476.765v2.326c0 .518.159.776.476.776.318 0 .477-.258.477-.776zM27 22.99c0 1.729-.096 3.022-.288 3.879a2.105 2.105 0 01-.643 1.097 1.938 1.938 0 01-1.13.51c-1.36.155-3.41.232-6.15.232s-4.79-.077-6.15-.233a1.964 1.964 0 01-1.136-.51 2.026 2.026 0 01-.637-1.096c-.192-.828-.288-2.12-.288-3.879 0-1.728.096-3.021.288-3.878a2.11 2.11 0 01.643-1.097 2.01 2.01 0 011.141-.52c1.352-.149 3.398-.223 6.14-.223 2.74 0 4.79.074 6.149.222.428.052.807.226 1.136.521.329.296.54.661.637 1.097.192.827.288 2.12.288 3.878zM15.941 8.851h1.13l-1.34 4.421v3.003h-1.108v-3.003c-.104-.546-.33-1.33-.676-2.349a95.617 95.617 0 01-.72-2.072H14.4l.787 2.914.753-2.914zm4.1 3.69v1.94c0 .598-.103 1.033-.31 1.307-.28.377-.672.565-1.175.565-.495 0-.882-.189-1.163-.565-.207-.281-.31-.717-.31-1.308v-1.939c0-.591.103-1.023.31-1.296.28-.377.668-.566 1.163-.566.503 0 .894.189 1.175.566.207.273.31.705.31 1.296zm3.712-1.795v5.53h-1.008v-.61c-.392.458-.772.687-1.141.687-.34 0-.558-.137-.654-.41-.06-.178-.089-.454-.089-.831v-4.366h1.008v4.067c0 .243.004.373.012.387.022.163.1.244.232.244.2 0 .41-.159.632-.476v-4.222h1.008z"
                              fill="#fff"
                            ></path>
                          </svg>
                        </a>
                        <a
                          href="https://linkedin.com"
                          title="LinkedIn"
                          data-footer-link="social"
                        >
                          <svg
                            width="32"
                            aria-hidden="true"
                            fill="#0057AD"
                            viewBox="0 0 37 37"
                          >
                            <circle
                              cx="18.5"
                              cy="18.5"
                              r="17.5"
                              stroke="currentColor"
                              stroke-width="2"
                            ></circle>
                            <path
                              fill="currentColor"
                              d="M15.134 25H12.23v-9.347h2.903V25zM13.68 14.378a1.695 1.695 0 01-1.681-1.697 1.681 1.681 0 013.362 0c0 .928-.753 1.697-1.681 1.697zM25.997 25H23.1v-4.55c0-1.084-.022-2.475-1.51-2.475-1.509 0-1.74 1.178-1.74 2.397V25h-2.9v-9.347h2.785v1.275h.04c.388-.734 1.334-1.51 2.747-1.51 2.937 0 3.477 1.935 3.477 4.448V25h-.003z"
                            >
                              {" "}
                            </path>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-100 border border-top-gray-400">
                <div className="container p-6 py-10 mx-auto">
                  <p className="text-xs">{`${t(
                    "copyright"
                  )} SpeedyHR ${moment().format("YYYY")}`}</p>
                </div>
              </div>
            </footer>
            <div className="fixed bottom-0 z-20 w-full"></div>
          </div>
        </div>
        <div
          id="gatsby-announcer"
          style={{
            position: "absolute",
            top: "0px",
            width: "1px",
            height: "1px",
            padding: "0px",
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            border: "0px",
          }}
          aria-live="assertive"
          aria-atomic="true"
        ></div>
      </div>
      <div
        className="modal fade"
        id="askForDemoModal"
        tabindex="-1"
        aria-labelledby="askForDemoModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h5 className="modal-title" id="exampleModalLabel">
                {t("requestConsultation")}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-mdb-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p className="text-center">{t("speedyHrTakesCareOfYourNeeds")}</p>
              <div>
                <div className="form-group">
                  <input
                    placeholder="Business Email*"
                    type={"text"}
                    className="filter-form"
                  />
                </div>
                <div className="form-group">
                  <input
                    placeholder="Mobile Number*"
                    type={"text"}
                    className="filter-form"
                  />
                </div>
                <div className="form-group mb-2">
                  <textarea
                    style={{ width: "100%", maxHeight: 180, minHeight: 100 }}
                    maxLength={450}
                    placeholder="Your Comments"
                    className="filter-form-t-area"
                  />
                </div>
                <div className="form-group">
                  <button
                    className="btn btn-block btn-primary-cs"
                    data-mdb-dismiss="modal"
                    aria-label="Close"
                  >
                    {t("submit")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
